import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { NodeTypeEnum } from '../../../../../services/eleview/types/model';
import { Node } from '../../../../../services/eleview/types/node';
import { Operates } from '../../../../../services/eleview/types/operate';
import { EditLabelService } from '../../edit-label.service';

@Component({
	selector: 'common-condition-node',
	templateUrl: './condition-node.component.html',
	styleUrls: ['./condition-node.component.scss']
})
export class ConditionNodeComponent implements OnInit, AfterViewInit {
	readonly Operates = Operates;
	readonly nodeTypeCondition = NodeTypeEnum.NodeCondition;
	@ViewChild('main', { static: false })
	dvMain: ElementRef;
	@Input() data: Node;
	@HostBinding('class.condition-node') hostClass = true;
	constructor(public lblSvr: EditLabelService, private ref: ElementRef) {}
	ngAfterViewInit() {
		this.dvMain.nativeElement.ondragover = (event: DragEvent) => {
			// ä¸è½èªå·±æå°èªå·±
			if (
				this.lblSvr.dragData &&
				this.lblSvr.dragData.Type === 'node' &&
				(this.lblSvr.dragData.Data as Node) === this.data
			) {
				return;
			}
			event.preventDefault();
			const rect = (this.ref.nativeElement as Element).getBoundingClientRect();
			const offsetY = event.pageY - rect.top;
			// const clientHeight = rect.height;
			if (this.lblSvr.dragOverNode !== this.data && this.lblSvr.prevNodeEle) {
				const ref = this.lblSvr.prevNodeEle.nativeElement as HTMLElement;
				ref.style.borderTop = '4px solid transparent';
				ref.style.borderBottom = '4px solid transparent';
				ref.style.backgroundColor = null;
			}
			// Handle drag area
			if (offsetY < 4) {
				(this.dvMain.nativeElement as HTMLElement).style.borderTop = '4px solid #67c204';
				(this.dvMain.nativeElement as HTMLElement).style.borderBottom = '4px solid transparent';
				(this.dvMain.nativeElement.childNodes[0] as HTMLElement).style.backgroundColor = null;
				this.lblSvr.dragOverArea = 'above';
			} else if (offsetY > 40) {
				(this.dvMain.nativeElement as HTMLElement).style.borderTop = '4px solid transparent';
				(this.dvMain.nativeElement.childNodes[0] as HTMLElement).style.backgroundColor = null;
				(this.dvMain.nativeElement as HTMLElement).style.borderBottom = '4px solid #67c204';
				this.lblSvr.dragOverArea = 'below';
			} else {
				(this.dvMain.nativeElement as HTMLElement).style.borderTop = '4px solid transparent';
				(this.dvMain.nativeElement as HTMLElement).style.borderBottom = '4px solid transparent';
				(this.dvMain.nativeElement.childNodes[0] as HTMLElement).style.backgroundColor = '#67c204';
				this.lblSvr.dragOverArea = 'center';
			}
			this.lblSvr.dragOverNode = this.data;
			this.lblSvr.prevNodeEle = this.dvMain;
			event.stopPropagation();
		};
	}
	ngOnInit() {}
	dropTop(event: DragEvent) {
		this.data.addTopSibling(this.lblSvr.buildDragedNode());
		if (this.lblSvr.dragData.Type === 'node') {
			(this.lblSvr.dragData.Data as Node).remove();
		}
	}
	dropBottom(event: DragEvent) {
		this.data.addBottomSibling(this.lblSvr.buildDragedNode());
		if (this.lblSvr.dragData.Type === 'node') {
			(this.lblSvr.dragData.Data as Node).remove();
		}
	}
	dropRight(event: DragEvent) {
		this.data.addChildSibling(this.lblSvr.buildDragedNode());
		if (this.lblSvr.dragData.Type === 'node') {
			(this.lblSvr.dragData.Data as Node).remove();
		}
	}
	drop(event: DragEvent) {
		switch (this.lblSvr.dragOverArea) {
			case 'above':
				this.dropTop(event);
				break;
			case 'below':
				this.dropBottom(event);
				break;
			case 'center':
				this.dropRight(event);
				break;
		}
		this.lblSvr.onNodeChange.emit();
		this.lblSvr.dragOverNode = null;
		if (this.lblSvr.prevNodeEle) {
			const ref = this.lblSvr.prevNodeEle.nativeElement as HTMLElement;
			ref.style.borderTop = '4px solid transparent';
			ref.style.borderBottom = '4px solid transparent';
			ref.style.backgroundColor = null;
		}
		event.stopPropagation();
	}
	dragStart(event: DragEvent) {
		this.lblSvr.dragData = { Type: 'node', Data: this.data };
	}
	dragover(event: DragEvent) {
		// console.log('dragend');
		this.dvMain.nativeElement.style.borderTop = '4px solid transparent';
		this.dvMain.nativeElement.style.borderBottom = '4px solid transparent';
		this.dvMain.nativeElement.childNodes[0].style.backgroundColor = null;
	}
	delete(event: MouseEvent) {
		this.data.remove();
		this.lblSvr.onNodeChange.emit();
	}
}
